<template>
  <modal-template v-if="products.length">
    <template #header>
      <div class="modal-header-style">
        <div style="float:left;padding-left:1%;padding-top:1%;font-weight:bold;font-size:larger;font-style:italic;">
          <span>products</span>
        </div>
        <div style="float:right;">
          <label class="action-icon-style" @click="rowReorder">
            <font-awesome-icon icon="xmark" size="xl"/>
            <span style="display: block;">close</span>
          </label>
        </div>
      </div>
      <div style="width:100%;float:left;padding-bottom:5%;">
        <div style="font-size:larger;font-weight:bold;"><sup>[{{ customerId }}]</sup> {{ customerName }}</div>
        <div>serviced by <sup>[{{ dairyId }}]</sup> {{ dairyName }}</div>
      </div>
    </template>
    <template #body>
      <div>
        <DataTable ref="productsTable" style="cursor:pointer;" class="display" width="100%"
                   :columns='columns'
                   :data='products'
                   :rowReorder='true'
                   :options="{
                     rowReorder: {
                       dataSrc: 'sortSequence',
                       selector: role === 'basic' ? 'tr' : '',
                     },
                     paging: false,
                     scrollY: 400,
                     buttons: [
                       {
                         text: 'reset', action: function ( e, dt, node, config ) {
                           dt.order( [ 0, 'asc' ] ).draw();
                           dt.rows().every( function () {
                             for (product of products) {
                               if (this.data().id === product.id && this.data().sortSequence !== product.defaultSortSequence) {
                                   this.data().sortSequence = product.defaultSortSequence
                               }
                             }
                           })
                         }
                       },
                       {
                         extend: 'pdfHtml5',
                         download: 'open',
                         text: 'print',
                         header: true,
                         footer: false,
                         exportOptions: {
                           columns: dairy.showPrice ? [1,2,4,3] : [1,2,4]
                         },
                         customize: function (doc) {
                           doc.title = 'Account Product List'
                           doc.content.splice(0,1)
                           doc.pageSize = 'LETTER'
                           doc.pageOrientation = 'portrait'
                           doc.pageMargins = [20,60,20,30]
                           doc.defaultStyle.fontSize = 14

                           doc.content[0].table.body[0][0].alignment = 'left'
                           doc.content[0].table.body[0][2].alignment = 'center'
                           doc.content[0].table.widths = dairy.showPrice ? [315,80,80,80] : [400,85,85]

                           let rowCount = doc.content[0].table.body.length
                           for (i = 1; i < rowCount; i++) {
                             doc.content[0].table.body[i][1].alignment = 'right'
                             doc.content[0].table.body[i][2].text === '✓' ? doc.content[0].table.body[i][2].text = '√' : doc.content[0].table.body[i][2].text = ''
                             doc.content[0].table.body[i][2].alignment = 'center'
                             dairy.showPrice ? doc.content[0].table.body[i][3].alignment = 'right' : ''
                           }

                           doc['header']=(function(currentPage, pageCount) {
                             const today = new Date()

                             return {
                               columns: [
                                 {
                                   margin: [20,10],
                                   fontSize: 12,
                                   text: [
                                     {text: 'Account Product List\r\n'},
                                     {text: '[' + customerId + ']', sup: true},
                                     {text: ' ' + customerName},
                                     {text: '\r\nas of: ' + today.toLocaleDateString() + ' at ' + today.toLocaleTimeString()},
                                   ],
                                 },
                                 {
                                   margin: [20,10],
                                   fontSize: 10,
                                   text: [
                                     {text: 'page ' + currentPage + ' of ' + pageCount, alignment: 'right'}
                                   ],
                                 },
                               ],
                             }
                          })
                         },
                      },
                    ],
                    dom: 'Bftip',
                    info: false,
                   }">
        </DataTable>
      </div>
    </template>
    <template #footer>
    </template>
  </modal-template>
</template>

<script>
import ModalTemplate from '@/components/ModalTemplate'
import DataTable from 'datatables.net-vue3'
import DataTablesCore from 'datatables.net'
import 'datatables.net-buttons'
import 'datatables.net-buttons/js/buttons.html5'
import 'datatables.net-rowreorder'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'

DataTable.use(DataTablesCore)
pdfMake.vfs = pdfFonts.pdfMake.vfs
DataTablesCore.Buttons.pdfMake(pdfMake)

export default {
  name: 'List',
  components: {
    DataTable,
    ModalTemplate,
  },
  props: ['dairyId', 'dairyName', 'customerId', 'customerName', 'priceDeck'],
  emits: ['close', 'apierror', 'apierrortext'],
  data: function () {
    return {
      dairy: {},
      products: [],
      role: '',
    }
  },
  methods: {
    rowReorder() {
      if (this.role === 'basic' && _.find(this.products, function(o) { return o.sortSequence !== o.defaultSortSequence })) {
        this.axios
            .post(
                'account/setUserProductSequence',
                {
                  dairyId: this.dairyId,
                  customerId: this.customerId,
                  username: this.$store.getters.getUsername,
                  products: this.products
                }
            )
            .catch(error => {
              this.$emit('apierror', true)
              this.$emit('apierrortext', error.response.statusText)
            })
      }

      this.$emit('close', true)
    }
  },
  computed: {
    columns: function () {
      return [
        {
          title: 'seq',
          name: 'sort_sequence',
          orderable: true,
          data: 'sortSequence',
          visible: false,
          searchable: false,
        },
        {
          title: 'product',
          name: 'product',
          orderable: false,
          data: null,
          render: function (data) {
            return data.outOfStock ?
                '<div class="outOfStock"><sup>[' + data.id + ']</sup> ' + data.name + '</div>' :
                '<sup>[' + data.id + ']</sup> ' + data.name
          }
        },
        {
          title: this.dairy.bypassOrderEntry ? 'case qty' : 'units per',
          name: 'units_per',
          orderable: false,
          class: 'dt-right',
          data: null,
          render: function (data) {
            return data.packText ? data.packText : data.unitsPerPackaging
          }
        },
        {
          title: 'price per',
          name: 'price_per',
          orderable: false,
          class: 'dt-right',
          data: null,
          visible: this.dairy.showPrice,
          render: function (data) {
            return data.pricePer.toLocaleString(
                'en-US', {
                  style: 'currency',
                  currency: 'USD',
                  minimumFractionDigits: 4
                }
            )
          }
        },
        {
          title: 'full pack req.',
          name: 'full_pack_req',
          orderable: false,
          class: 'dt-center',
          data: null,
          render: function (data) {
            return data.fullPackaging ? '<span style="font-size:larger;color:green;font-weight:bold;">&#10003;</span>' : ''
          }
        }
      ]
    },
  },
  mounted() {
    this.role = this.$store.getters.getRole

    this.axios
        .get('account/products', {
          params: {
            dairyId: this.dairyId,
            priceDeck: this.priceDeck,
            accountId: this.customerId,
          }
        })
        .then(response => {
          this.dairy = response.data.dairy
          this.products = _.sortBy(response.data.products, ['sortSequence'])
        })
        .catch(error => {
          this.$emit('apierror', true)
          this.$emit('apierrortext', error.response.statusText)
        })
  },
}
</script>

<style scoped>
@import 'datatables.net-dt';
@import 'datatables.net-buttons-dt';
@import 'datatables.net-rowreorder-dt';

.modal-header-style {
  width: 100%;
  float: left;
  background: black;
  color: white;
  border-radius: 4px;
}

.action-icon-style {
  color: white;
  text-align: center;
  cursor: pointer;
  width: 80px;
}

.action-icon-style:hover {
  font-weight: bolder;
}
</style>
